import React from 'react';
import { noDealsvg } from '../../DealsAndDiscounts/Components/ProductListing/svg';
const ZeroOrders = ({ orderStatus, orders, loadingOrders }) => {
    return (
        <div>
            <div className="mt-4 px-4 lg:px-0">
                <div className="w-full pl-0 xl:pl-6 mt-4 border border-gray-300 rounded-xl">
                    <div className="flex flex-row items-center justify-center p-7 gap-5">
                        <div className="mt-1 lg:mt-0">{noDealsvg}</div>
                        <div className="flex flex-col">
                            <p className="text-2xl font-bold">Oops!</p>
                            <p className="whitespace-nowrap mt-2">
                                No Orders found
                            </p>

                            {orders?.length === 0 &&
                            !loadingOrders &&
                            orderStatus !== 'Shipped' &&
                            orderStatus !== 'Delivered' ? (
                                <p className="xl:whitespace-nowrap mt-1 text-gray-400">
                                    You haven’t made any purchases yet. Claim
                                    your rewards to start shopping and enjoy
                                    exclusive offers!
                                </p>
                            ) : (
                                <p className="xl:whitespace-nowrap mt-1 text-gray-400">
                                    No orders have reached this stage yet. Once
                                    your orders are shipped or delivered, you'll
                                    see them here!
                                </p>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ZeroOrders;
